import app from "./../img/icons/app.svg";
import card from "./../img/icons/card.svg";
import cart from "./../img/icons/cart.svg";
import customer from "./../img/icons/customer.svg";
import domain from "./../img/icons/domain.svg";
import ecommerce from "./../img/icons/ecommerce.svg";
import host from "./../img/icons/host.svg";
import illust from "./../img/icons/illust.svg";
import promo from "./../img/icons/promo.svg";
import qr from "./../img/icons/qr.svg";
import report from "./../img/icons/report.svg";
import rwd from "./../img/icons/rwd.svg";
import searchop from "./../img/icons/searchop.svg";
import secure from "./../img/icons/secure.svg";
import seo from "./../img/icons/seo.svg";
import tecnologyPoint150 from "./../img/marks/tecnologyPoint150.jpg";
import tecnologyPointClient from "./../img/marks/tecnologyPointClient.jpg";
import fotoRenato150 from "./../img/marks/fotoRenato150.jpg";
import fotoRenatoClient from "./../img/marks/fotoRenatoClient.jpg";
import shopSafe150 from "./../img/marks/shopSafe150.jpg";
import shopSafeClient from "./../img/marks/shopSafeClient.jpg";
import librosPapeles150 from "./../img/marks/librosPapeles150.jpg";
import librosPapelesClient from "./../img/marks/librosPapelesClient.jpg";
import marySal150 from "./../img/marks/marySal150.jpg";
import marySalClient from "./../img/marks/marySalClient.jpg";
import parfaite150 from "./../img/marks/parfaite150.jpg";
import parfaiteClient from "./../img/marks/parfaiteClient.jpg";

export const Services = [
  {
    id: 5,
    hash: "tienda",
    name: "Tiendas Virtuales",
    description:
      "Crea hoy mismo una tienda que esté abierta las 24 horas, te ayude a llegar a miles de clientes y agilizar pagos de forma segura. Arriésgate y da el siguiente paso hacia el futuro entrando al mundo digital. En Time Lab te ayudamos a hacerlo, ¿qué esperas? ",
    tiers: [
      {
        title: "Básico",
        price: "249",
        percent: 0.2,
        description: [
          "Diseño Web Personalizado",
          "Adaptable a Cualquier Dispositivo",
          "Galería / Catálogo Digital",
          "Categorías de Productos",
          "Formulario de Contacto",
          "Posicionamiento de Google",
          "Enlaces a Redes Sociales",
          "100% Autoadministrable",
          "1 año Certificado SSL",
          "1 año Dominio Propio",
          "1 año Hosting",
          "1 año Cuenta FTP",
          "Capacitación de manejo 2h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
      {
        title: "Ideal",
        subheader: "El más popular",
        price: "469",
        percent: 0.3,
        description: [
          "PLAN BÁSICO",
          "Slider de 2 Imágenes",
          "Carrito de Compras",
          "Sistema de Pago / Reserva",
          "Pago por Débito o Crédito",
          "Branding de la Marca",
          "Google Analytics",
          "Capacitación de Manejo 2h",
        ],
        buttonText: "Adquirir Ahora!",
        buttonVariant: "contained",
      },
      {
        title: "Premium",
        price: "729",
        percent: 0.2,
        description: [
          "PLAN IDEAL",
          "Slider de 5 Imágenes",
          "Categorías de Productos",
          "Pago por Paypal / Tarjetas de Débito o Crédito",
          "Botón de Mensajería Instantánea",
          "1 año Correos Corporativos",
          "Logotipo Personalizado",
          "Colores e Identidad",
          "Tipografía y Diseño",
          "Capacitación de Manejo 4h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
    ],
  },
  {
    id: 6,
    hash: "portafolio",
    name: "Portafolio",
    description:
      "Da el siguiente paso y muestra todo tu potencial al mundo, enseña lo que puedes hacer mediante galerías de imágenes, sliders, post informativos entre otras. Llega a miles de personas de una forma personalizada y profesional. En Time Lab te ayudamos a hacerlo, ¿qué esperas? ",
    tiers: [
      {
        title: "Básico",
        price: "229",
        percent: 0.2,
        description: [
          "Diseño Web Personalizado",
          "Adaptable a Cualquier Dispositivo",
          "One Page",
          "Galería de Imágenes",
          "Formulario de Contacto",
          "Enlaces a Redes Sociales",
          "100% Autoadministrable",
          "1 año Certificado SSL",
          "1 año Dominio Propio",
          "1 año Hosting",
          "Capacitación de Manejo 2h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
      {
        title: "Ideal",
        subheader: "El más popular",
        price: "329",
        percent: 0.3,
        description: [
          "PLAN BÁSICO",
          "5 Secciones",
          "Galería de Imágines / Videos",
          "Posicionamiento de Google",
          "Google Analytics",
          "Capacitación de Manejo 2h",
        ],
        buttonText: "Adquirir Ahora!",
        buttonVariant: "contained",
      },
      {
        title: "Premium",
        price: "429",
        percent: 0.2,
        description: [
          "PLAN IDEAL",
          "10 Secciones",
          "SEO Avanzado",
          "Botón de mensajería Instantánea",
          "Logotipo Personalizado",
          "Creación de redes sociales",
          "Capacitación de Manejo 4h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
    ],
  },
  {
    id: 7,
    hash: "corporativa",
    name: "Web Coorporativa",
    description:
      "Da una imágen profesional y seria a tu empresa e interactua de una forma más personalizada con tus empleados y clientes mediante una web corporativa. Abre las puertas al mundo digital. En Time Lab te ayudamos a hacerlo, ¿qué esperas? ",
    tiers: [
      {
        title: "Básico",
        price: "269",
        percent: 0.2,
        description: [
          "Diseño Web Personalizado",
          "Adaptable a Cualquier Dispositivo",
          "Banner Inicio",
          "4 Secciones",
          "6 Subsecciones",
          "Formulario de Contacto",
          "Posicionamiento de Google",
          "Enlaces a Redes Sociales",
          "100% Autoadministrable",
          "1 año Certificado SSL",
          "1 año Dominio Propio",
          "1 año Hosting",
          "1 año Cuenta FTP",
          "Capacitación de manejo 2h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
      {
        title: "Ideal",
        subheader: "El más popular",
        price: "369",
        percent: 0.3,
        description: [
          "PLAN BÁSICO",
          "Slider de 2 Imágenes",
          "6 Secciones",
          "8 Subsecciones",
          "Mapa del Sitio",
          "Localización de la Empresa",
          "Opción de Búsqueda",
          "Branding de la Marca",
          "Google Analytics",
          "Capacitación de Manejo 2h",
        ],
        buttonText: "Adquirir Ahora!",
        buttonVariant: "contained",
      },
      {
        title: "Premium",
        price: "469",
        percent: 0.2,
        description: [
          "PLAN IDEAL",
          "Slider de 5 Imágenes",
          "Secciones Ilimitadas",
          "Botón de Mensajería Instantánea",
          "Formulario de Subscripción",
          "e-mail Marketing",
          "1 año Correos Corporativos",
          "Logotipo Personalizado",
          "Colores e Identidad",
          "Tipografía y Diseño",
          "Capacitación de Manejo 4h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
    ],
  },
  {
    id: 8,
    hash: "marketing",
    name: "Márketing Digital",
    description:
      "Crea una comunidad online que esté interesada en tu producto o servicio, incrementa el alcance de tus clientes rompiendo fronteras mediantes estrategias eficaces en redes sociales. Genera contenido, seguirdores y visualizaciones que empujen tu negocio hacia el futuro y aumenten tus ventas. En Time Lab te ayudamos a hacerlo, ¿qué esperas? ",
    tiers: [
      {
        title: "Básico",
        price: "59",
        percent: 0.2,
        month: "/mes",
        description: [
          "Breafing",
          "8 Artes",
          "1 Video 30seg",
          "Manejo de Facebook o Instagram",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
      {
        title: "Ideal",
        subheader: "El más popular",
        price: "75",
        percent: 0.3,
        month: "/mes",
        description: [
          "PLAN BÁSICO",
          "Reporte Estadístico",
          "12 Artes",
          "2 Videos 30seg",
          "Manejo de Facebook e Instagram",
        ],
        buttonText: "Adquirir Ahora!",
        buttonVariant: "contained",
      },
      {
        title: "Premium",
        price: "99",
        percent: 0.2,
        month: "/mes",
        description: [
          "PLAN IDEAL",
          "16 Artes",
          "3 Videos 30seg",
          "Sesión de fotos del Servicio o Producto",
          "Campañas Facebook Ads",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
    ],
  },
  {
    id: 9,
    hash: "blog",
    name: "Blogs / Foros",
    description:
      "Mejora la interacción con tus seguidores, aprovecha el feedback de los mismo para generar contenido, posiciona tu nombre o marca en buscadores, crea una reputación online y muestrate de forma profesional. En Time Lab te ayudamos a hacerlo, ¿qué esperas? ",
    tiers: [
      {
        title: "Ideal",
        subheader: "El más popular",
        price: "199",
        percent: 0.2,
        description: [
          "Diseño Web Personalizado",
          "Adaptable a Cualquier Dispositivo",
          "Banner Inicio",
          "Posicionamiento de Google",
          "Enlaces a Redes Sociales",
          "100% Autoadministrable",
          "10 Categorias",
          "Comentarios con Registro",
          "Google Analytics",
          "1 año Certificado SSL",
          "1 año Dominio Propio",
          "1 año Hosting",
          "1 año Cuenta FTP",
          "Capacitación de manejo 2h",
        ],
        buttonText: "Adquirir Ahora!",
        buttonVariant: "contained",
      },
      {
        title: "Premium",
        price: "299",
        percent: 0.3,
        description: [
          "PLAN IDEAL",
          "Slider 2 Imágenes",
          "Categorías Ilimitadas",
          "Comentarios con y sin Registro",
          "e-mail Marketing",
          "Capacitación de manejo 4h",
        ],
        buttonText: "Adquirir",
        buttonVariant: "outlined",
      },
    ],
  },
];

export const Data = [
  {
    id: 1,
    title: "Hugo Fernandez",
    description:
      "Tienda Virtual, elaborada a Tecnology Point para venta de artículos tecnológicos.",
    nameMark: "Tecnology Point",
    imgMark: tecnologyPoint150,
    imgMark150: tecnologyPoint150,
    calification: "5",
    imgClient: tecnologyPointClient,
    testimonial:
      "Muchas gracias a ustedes por realizar la página web de mi empresa, obtuve un excelente resultado, gracias al sitio web he logrado consolidar muchas y expandirme.",
    date: "Diciembre 12, 2019",
  },
  {
    id: 2,
    title: "Renato Portilla",
    description:
      "Portafolio virual, elaborado a FotoRenato, para exhibición de servicio fotográfico.",
    nameMark: "FotoRenato",
    imgMark: fotoRenato150,
    imgMark150: fotoRenato150,
    calification: "5",
    imgClient: fotoRenatoClient,
    testimonial:
      "Me gustó la atención personalizada que tienen, siempre buscaron lo mejor para que mi sitio web sobresaliera, Estoy muy conforme con los resultados.",
    date: "Mayo 15, 2020",
  },
  {
    id: 3,
    title: "Alejandro Aguirre",
    description:
      "Tienda Virtual, desarrollada para ShopSafe, multicomerce para la venta de productos",
    nameMark: "ShopSafe",
    imgMark: shopSafe150,
    imgMark150: shopSafe150,
    calification: "5",
    imgClient: shopSafeClient,
    testimonial:
      "Gracias a esta página web pude tener un catálogo mucho más organizado y efectivo de los productos que vende mi empresa. Gracias a Time Lab por su trabajo personalizado y puntual.",
    date: "Septiembre 20, 2020",
  },
  {
    id: 4,
    title: "Maira Sanchez",
    description:
      "Tienda Virtual, desarrollada para Libros & Papeles, venta de artículos de papelería",
    nameMark: "Libros & Papeles",
    imgMark: librosPapeles150,
    imgMark150: librosPapeles150,
    calification: "5",
    imgClient: librosPapelesClient,
    testimonial:
      "Un amigo me sugirió encargar mi pagína Web con esta agencia, la verdad no me arrepiento de nada. Agradezco su profesionalismo, puntualidad y seriedad. Mi web quedó hermosa.",
    date: "Julio 23, 2020",
  },
  {
    id: 5,
    title: "Joselo Castro",
    description:
      "Web Coorporativa, elaborada a Mar y Sal, para reserva y presentación del Hotel",
    nameMark: "Mar y Sal",
    imgMark: marySal150,
    imgMark150: marySal150,
    calification: "5",
    imgClient: marySalClient,
    testimonial:
      "Realizar una página web me ayudó a que mis clientes puedan reservar habitaciones con mayor facilidad, esto aumentó las visitan a mi hotel. Muy serios los chicos para trabajar.",
    date: "Agosto 27, 2020",
  },
  {
    id: 6,
    title: "Mariana Salas",
    description:
      "Web Coorporativa, elaborada a Parfaite, para reserva y muestra de productos de belleza",
    nameMark: "Parfaite",
    imgMark: parfaite150,
    imgMark150: parfaite150,
    calification: "4.5",
    imgClient: parfaiteClient,
    testimonial:
      "Al empezar mi emprendimiento no sabía cómo dar a conocer mis productos, el equipo de Time Lab me ayudó con la creación de mi propio sitio web y el marketing, ahora tengo muchos clientes.",
    date: "September 9, 2020",
  },
];

export const Icon = [
  {
    id: 1,
    title: "SEO",
    image: seo,
  },
  {
    id: 2,
    title: "Desarrollo de Apps",
    image: app,
  },
  {
    id: 3,
    title: "Métodos de pago",
    image: card,
  },
  {
    id: 4,
    title: "E-commerce",
    image: ecommerce,
  },
  {
    id: 5,
    title: "Dominio propio",
    image: domain,
  },
  {
    id: 6,
    title: "Hosting",
    image: host,
  },
  {
    id: 7,
    title: "Clientes",
    image: customer,
  },
  {
    id: 8,
    title: "Carrito de compras",
    image: cart,
  },
  {
    id: 9,
    title: "Diseño creativo",
    image: illust,
  },
  {
    id: 10,
    title: "Generación de reportes",
    image: report,
  },
  {
    id: 11,
    title: "Códigos QR",
    image: qr,
  },
  {
    id: 12,
    title: "Marketing",
    image: promo,
  },
  {
    id: 13,
    title: "Diseño Responsive",
    image: rwd,
  },
  {
    id: 14,
    title: "Búsquedas Optimizadas",
    image: searchop,
  },
  {
    id: 15,
    title: "Seguridad",
    image: secure,
  },
];
